import { get, post } from './http-calls';

export const getWorkshopShiftsList = async () => {
    let res = await get(`WorkshopShifts/WorkshopShiftsList`, {
        useAuthToken: true
    });
    return res;
};

export const getWorkshopShiftsByID = async (id) => {
    let res = await get(`WorkshopShifts/${id}`, {
        useAuthToken: true
    });
    return res;
};

export const postWorkshopShiftsAddUpdate = async (data) => {
    let res = await post(`WorkshopShifts/WorkshopShiftsAddUpdate`, data, {
        useAuthToken: true
    });
    return res;
};
